import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Meta } from './Meta'
export const HeadGear = ({ children }) => {
    return ReactDOM.createPortal(children, document.head)
}

HeadGear.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element, 
        PropTypes.arrayOf(PropTypes.element)
    ])
}

HeadGear.Meta = Meta
